/**
 * desc 添加车辆Modal
 * 功能：搜索添加车辆至表格中
 * */
import React, { Component } from 'react';
import { Form, Table, Input, Modal, DatePicker, notification } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { FormLayout, WhiteSpace, CarPosition, SelectQuery } from '@/components';
import moment from 'moment';
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class AddCarTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            carTable: [
                {
                    title: '车型',
                    dataIndex: 'carModelName',
                    width: 300,
                    align: 'left',
                    render: (text, record) => {
                        const showIcon = record.reportType === 1;
                        const v268 = require('@/assets/report/268v_2.png');
                        return (<span>
                {showIcon && <img src={v268} style={{
                            width: 36,
                            height: 18,
                            marginRight: 6,
                        }}/>}
                {text}
              </span>);
                    },
                },
                {
                    title: '车辆所在地',
                    dataIndex: 'locationName',
                    align: 'left',
                },
                {
                    title: '卖家经销商',
                    dataIndex: 'sellerName',
                    align: 'left',
                },
                {
                    title: '车牌号',
                    dataIndex: 'license',
                    align: 'left',
                },
                {
                    title: 'VIN码',
                    dataIndex: 'vin',
                    align: 'left',
                },
                {
                    title: '车况等级',
                    dataIndex: 'rankDesc',
                    align: 'left',
                    render: (text, row) => {
                        return (<span>{row.rankLevel}{text}</span>);
                    },
                },
                {
                    title: '状态',
                    dataIndex: 'statusDesc',
                    align: 'left',
                },
                {
                    title: '保留价(元)',
                    dataIndex: 'basePriceYuan',
                    align: 'left',
                },
                // {
                //   title: '收购价（元）',
                //   dataIndex: 'buyPriceYuan',
                //   align: 'left',
                // },
                {
                    title: '起拍价（元）',
                    dataIndex: 'auctionPriceYuan',
                    align: 'left',
                },
            ],
            checkedVal: {},
            checked: 0,
        };
        this.cancel = this.cancel.bind(this);
        this.addCar = this.addCar.bind(this);
        this.clear = this.clear.bind(this);
        this.searchTable = this.searchTable.bind(this);
        this.changeChecked = this.changeChecked.bind(this);
    }
    // desc 表格搜索
    searchTable(data) {
        this.queryTableData(1, data);
    }
    // desc 请求车辆数据
    queryTableData(index, data) {
        const params = data || {};
        if (params.time) {
            params.startTime = params.time[0];
            params.endTime = params.time[1];
            delete params.time;
        }
        if (params.locationCode) {
            params.localProvinceCode = data.locationCode[0];
            params.locationCode = data.locationCode[1];
        }
        dispatch.session.SET_STATE({
            addModalForm: params || null,
        });
        dispatch.session.queryAddModalTable({
            pageIndex: index,
            params: params || null,
        });
    }
    // desc 限制审核通过时间
    dealDate(currentDate) {
        const now = moment();
        return currentDate > now;
    }
    // desc 表单
    renderForm() {
        const { getFieldDecorator } = this.props.form;
        return (<FormLayout form={this.props.form} onSearch={this.searchTable}>
        <Form.Item label={'车辆所在地'}>
          {getFieldDecorator('locationCode', {
            initialValue: [],
        })(<CarPosition />)}
        </Form.Item>
        <Form.Item label={'VIN码/车牌号'}>
          {getFieldDecorator('code', {
            initialValue: '',
        })(<Input placeholder={'请输入VIN码/车牌号'}/>)}
        </Form.Item>
        <Form.Item label={'经销商名称'}>
          {getFieldDecorator('sellerCode')(<SelectQuery labelInValue={false}/>)}
        </Form.Item>
        <Form.Item label={'审批通过时间'}>
          {getFieldDecorator('time', {
            initialValue: [],
        })(<DatePicker.RangePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} className={'width-100'} disabledDate={this.dealDate}/>)}
        </Form.Item>
      </FormLayout>);
    }
    // desc 表格
    renderTable() {
        const { checkedVal, checked } = this.state;
        const { addIndex, pageSize, addModalTable, addTotal } = this.props.session;
        return (<div>
        共搜索到{addTotal}条数据
        <Table rowKey={'goodsId'} columns={this.state.carTable} rowSelection={{
            selectedRowKeys: Object.keys(checkedVal),
            onChange: this.changeChecked,
        }} dataSource={addModalTable} footer={(currentTableData) => {
            return (<span>{`已选中${checked}辆车`}</span>);
        }} pagination={{
            current: addIndex,
            pageSize,
            total: addTotal,
            onChange: (page) => {
                dispatch.session.queryAddModalTable({
                    pageIndex: page,
                });
            },
        }}/>
      </div>);
    }
    // desc checkbox change回调
    changeChecked(selectedRowKeys, selectedRows) {
        const { checkedVal } = this.state;
        const { addModalTable } = this.props.session;
        addModalTable.forEach((item) => {
            if (selectedRowKeys.includes(item.goodsId)) {
                item.goodsId && (checkedVal[item.goodsId] = item);
            }
            else {
                delete checkedVal[item.goodsId];
            }
        });
        const checkedNum = Object.keys(checkedVal).length;
        this.setState({
            checkedVal,
            checked: checkedNum,
        });
    }
    // desc 添加
    addCar() {
        const { checkedVal } = this.state;
        const allCheckedVal = Object.values(checkedVal);
        const allCheckedKey = Object.keys(checkedVal);
        if (allCheckedVal.length > 0) {
            dispatch.session.addModalDataToTable({
                rowList: allCheckedVal,
                idList: allCheckedKey,
            });
        }
        else {
            notification.warn({
                message: '请先选择车辆',
            });
        }
    }
    // desc 取消
    cancel() {
        dispatch.session.SHOW_ADD_MODAL(false);
    }
    // desc modal隐藏后重置数据
    clear() {
        dispatch.session.resetModal({});
        this.setState({
            checkedVal: {},
            checked: 0,
        });
        this.props.form.resetFields();
    }
    render() {
        const { showAddModal } = this.props.session;
        return (<Modal visible={showAddModal} width={'95%'} centered title={'添加车辆'} onCancel={this.cancel} onOk={this.addCar} afterClose={this.clear}>
        <React.Fragment>
          {this.renderForm()}
          <WhiteSpace />
          {this.renderTable()}
        </React.Fragment>
      </Modal>);
    }
}
export default connect(mapStateToProps)(Form.create({})(AddCarTable));
